<form
  class="navbar-search theme-background-color rounded-border mr-4 flex items-center gap-2"
  [ngClass]="{
    'navbar-search-open absolute z-50 mx-auto my-0 md:bottom-0 lg:right-full lg:w-[30rem] lg:pr-0':
      searchOpen() && inNavbar
  }"
  [formGroup]="searchForm"
  (keyup.enter)="onSearchClicked($event)">
  <button
    type="button"
    pButton
    icon="fa-solid fa-arrow-left"
    class="p-button-navbar-icon theme-text-color md:hidden"
    [ngClass]="{
      hidden: !searchOpen() || !inNavbar
    }"
    (click)="openSearch(false)"></button>
  <span
    class="p-input-icon-left hidden w-full items-center md:flex"
    [ngClass]="{
      flex: searchOpen() || !inNavbar
    }">
    <i class="fa-regular fa-search z-10 text-gray-600"></i>
    <p-autoComplete
      formControlName="search"
      [placeholder]="'common.button.search' | translate"
      field="title"
      class="search-autocomplete w-full outline-0"
      inputStyleClass="w-full h-full h-[40px]! px-12 outline-0"
      panelStyleClass="mt-1 lg:w-[30rem] search-autocomplete outline-0"
      inputId="search-autocomplete"
      appendTo="body"
      scrollHeight="100vh"
      [delay]="750"
      [group]="true"
      [dropdown]="false"
      [lazy]="true"
      [suggestions]="searchOpen() ? suggestions() : []"
      [minLength]="0"
      [completeOnFocus]="true"
      (completeMethod)="liveSearch($event, kkcFilter)"
      (onFocus)="openAutoComplete()"
      (onBlur)="closeAutoComplete($event)">
      <ng-template let-item #group>
        <div class="flex items-center justify-between border-b border-gray-300 bg-gray-100 px-4 py-2">
          <span class="mr-4 text-left text-base leading-normal font-medium text-gray-800"
            >{{ item.label | translate }}
          </span>
          <a
            [routerLink]="['ROUTES.search' | localize]"
            [queryParams]="{
              query: searchForm.get('search').value,
              module: item.value,
              reuse: false
            }"
            class="pointer-events-auto flex items-center text-left text-sm leading-tight font-medium whitespace-nowrap text-blue-400 hover:text-blue-700!"
            >{{ 'searchresults.all' | translate }}
          </a>
        </div>
      </ng-template>
      <ng-template let-item #item>
        <ng-container *ngIf="suiteViewPath + '/' + item.path | decodeUrl as url">
          <a
            class="p-menuitem-link flex flex-col gap-1 no-underline"
            [routerLink]="url.segments"
            [queryParams]="url.queryParams">
            <span class="overflow-hidden text-ellipsis whitespace-nowrap text-gray-700">{{ item.title }}</span>
            <span class="overflow-hidden text-xs text-ellipsis whitespace-nowrap text-gray-600">{{
              item.subtitle
            }}</span>
          </a>
        </ng-container>
      </ng-template>
      <ng-template let-loadingIcon #loadingicon
        ><i *ngIf="searchOpen()" class="fa-regular fa-circle-notch"></i
      ></ng-template>
    </p-autoComplete>
    <button
      class="navbar-search-button theme-alternating-color theme-border-color theme-text-color"
      type="button"
      pButton
      icon="fa-regular fa-search"
      (click)="onSearchClicked($event)"></button>
  </span>
  <button
    type="button"
    pButton
    icon="fa-solid fa-magnifying-glass"
    class="p-button-navbar-icon theme-text-color md:hidden"
    [ngClass]="{
      hidden: searchOpen() || !inNavbar
    }"
    (click)="openSearch(true, 'search-autocomplete')"></button>
</form>
